import { defineGameCard, onResolve } from '../authoring/index.js';
import { plannedTarget } from './helpers.js';
export const DefensiveCircuitCard = defineGameCard({
    id: 'defensive_circuit',
    gameplay: {
        type: 'SPELL', cost: 2,
        planning: { target: 'unit', unitFilter: 'ally' },
    },
    presentation: {
        name: 'Защитный контур',
        description: 'Дайте выбранной союзной карте Щит 3. Когда Щит полностью израсходован, охладите карту на 1.',
        glyph: {
            colors: ['#10213A', '#DADAE0', '#485583', '#5B6995', '#5B6995'],
            rows: [
                '.......1.....11.....',
                '1......1....11......',
                '11......1..11.......',
                '.1.......11.........',
                '..11...112211...111.',
                '...1.1123333211.1...',
                '....124344443421....',
                '....123444444321....',
                '....123433334321....',
                '...112344444432111..',
                '111..1344333431..11.',
                '.....1344444441...11',
                '.....1234444321....1',
                '...11.12344321......',
                '1111...123321.1.....',
                '........1441..11....',
                '.......1.11....1....',
                '......11...1....1...',
                '.....11....11...11..',
                '............1.....1.',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve((ctx) => {
            const targetId = plannedTarget(ctx);
            if (targetId !== undefined)
                ctx.ops.addShield(DefensiveCircuitCard.id, targetId, 3, ctx.self.id, 1);
        }),
    ],
    ui: { mechanics: ['cool', 'shield'] },
});
//# sourceMappingURL=defensive-circuit.js.map